<div class="top">
    <div class="header">TO SERVICE MEMBERS MOVING TO <span class="colored">SAN DIEGO</span>,</div>
    <div class="subheader">THANKS FOR SERVING US, WE WANT TO SERVE <span class="colored">YOU</span>.</div>

    <div class="note-container">
        <div class="note">
            <div class="icon"></div>
            <div class="text">Built specifically for service members navigating PCS orders.</div>
        </div>
    </div>
</div>



<!-- <div class="process-container" *ngIf="step == 10"> -->
<!-- <div class="process"> -->
<!-- <div class="number">1</div> -->
<!-- <div class="text">Share your next PCS</div> -->
<!-- </div> -->
<!-- <div class="process"> -->
<!-- <div class="number">2</div> -->
<!-- <div class="text"> We review your options</div> -->
<!--  -->
<!-- </div> -->
<!-- <div class="process"> -->
<!-- <div class="number">3</div> -->
<!-- <div class="text">A specialist reaches out</div> -->
<!--  -->
<!-- </div> -->
<!-- </div> -->

<div class="installation-container">
    <div class="label">WHERE WILL YOU BE STATIONED?</div>
    <div class="address-card">
        <ng-select placeholder="Select your military installation" [items]="installations"
            [(ngModel)]="selected"></ng-select>
        <button (click)="goToStep2()" [disabled]="!selected"> 
            <div class="btn-text">Explore PCS Purchase Options</div>
            <div class="icon"></div>
        </button>
    </div>
</div>

<!-- <div class="audience-note"> -->
<!-- <div>Independent relocation guidance. Not affiliated with the U.S. Department of Defense.</div> -->
<!-- </div> -->